import { render, staticRenderFns } from "./receiveableLimitApply.vue?vue&type=template&id=5c89ef8c&scoped=true&"
import script from "./receiveableLimitApply.vue?vue&type=script&lang=js&"
export * from "./receiveableLimitApply.vue?vue&type=script&lang=js&"
import style0 from "./receiveableLimitApply.vue?vue&type=style&index=0&id=5c89ef8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c89ef8c",
  null
  
)

export default component.exports